/**
* Long-stay Suite — retirement/LTR/Elite/PR long residency cluster.
* 10 services × 15 nationalities = 150 matrix pages.
*/
export interface LongstayService {
  slug: string; nameTh: string; nameEn: string; intent: string; turnaround: string; gov: string;
}

export const LONGSTAY_SERVICES: readonly LongstayService[] = [
  { slug: "retirement-o", nameTh: "วีซ่าเกษียณอายุ Non-O (1 ปี)", nameEn: "Retirement Visa Non-O", intent: "เกษียณในไทย อายุ 50+", turnaround: "3-4 สัปดาห์", gov: "ตม." },
  { slug: "retirement-oa", nameTh: "วีซ่าเกษียณอายุ Non-O-A (Multi-entry)", nameEn: "Retirement Visa Non-O-A", intent: "เกษียณ + เดินทางออกได้", turnaround: "4-6 สัปดาห์", gov: "สถานทูตไทย" },
  { slug: "retirement-ox", nameTh: "วีซ่าเกษียณอายุ Non-O-X (10 ปี)", nameEn: "Retirement Visa Non-O-X", intent: "เกษียณ 10 ปี ครั้งเดียว", turnaround: "6-10 สัปดาห์", gov: "สถานทูตไทย + ตม." },
  { slug: "ltr-wealth", nameTh: "LTR — Wealthy Global Citizen", nameEn: "LTR Wealthy Global Citizen", intent: "สินทรัพย์ ≥ USD 1M", turnaround: "8-12 สัปดาห์", gov: "BOI" },
  { slug: "ltr-pensioner", nameTh: "LTR — Wealthy Pensioner", nameEn: "LTR Wealthy Pensioner", intent: "รายได้บำนาญ ≥ USD 80k", turnaround: "8-12 สัปดาห์", gov: "BOI" },
  { slug: "ltr-wfh", nameTh: "LTR — Work-From-Thailand Professional", nameEn: "LTR WFTP", intent: "รีโมท จากบริษัทต่างชาติ", turnaround: "8-12 สัปดาห์", gov: "BOI" },
  { slug: "ltr-hst", nameTh: "LTR — Highly-Skilled Professional", nameEn: "LTR HSP", intent: "ผู้เชี่ยวชาญ 10 อุตสาหกรรมเป้าหมาย", turnaround: "8-12 สัปดาห์", gov: "BOI" },
  { slug: "elite-5", nameTh: "Thailand Privilege 5 ปี (Gold)", nameEn: "Thailand Privilege Gold", intent: "อยู่ไทย 5 ปี", turnaround: "1-2 เดือน", gov: "TPC" },
  { slug: "elite-10", nameTh: "Thailand Privilege 10 ปี (Platinum)", nameEn: "Thailand Privilege Platinum", intent: "อยู่ไทย 10 ปี + สิทธิพิเศษ", turnaround: "1-2 เดือน", gov: "TPC" },
  { slug: "pr", nameTh: "ถิ่นที่อยู่ถาวร (Permanent Residence)", nameEn: "Permanent Residence PR", intent: "อยู่ถาวร → สู่สัญชาติ", turnaround: "12-18 เดือน", gov: "ตม./มท." },
] as const;

export interface LongstayCountry { slug: string; nameTh: string; nameEn: string; }
export const LONGSTAY_COUNTRIES: readonly LongstayCountry[] = [
  { slug: "usa", nameTh: "อเมริกา", nameEn: "United States" },
  { slug: "uk", nameTh: "สหราชอาณาจักร", nameEn: "United Kingdom" },
  { slug: "australia", nameTh: "ออสเตรเลีย", nameEn: "Australia" },
  { slug: "canada", nameTh: "แคนาดา", nameEn: "Canada" },
  { slug: "germany", nameTh: "เยอรมนี", nameEn: "Germany" },
  { slug: "france", nameTh: "ฝรั่งเศส", nameEn: "France" },
  { slug: "japan", nameTh: "ญี่ปุ่น", nameEn: "Japan" },
  { slug: "china", nameTh: "จีน", nameEn: "China" },
  { slug: "korea", nameTh: "เกาหลีใต้", nameEn: "South Korea" },
  { slug: "singapore", nameTh: "สิงคโปร์", nameEn: "Singapore" },
  { slug: "switzerland", nameTh: "สวิตเซอร์แลนด์", nameEn: "Switzerland" },
  { slug: "sweden", nameTh: "สวีเดน", nameEn: "Sweden" },
  { slug: "netherlands", nameTh: "เนเธอร์แลนด์", nameEn: "Netherlands" },
  { slug: "newzealand", nameTh: "นิวซีแลนด์", nameEn: "New Zealand" },
  { slug: "uae", nameTh: "สหรัฐอาหรับเอมิเรตส์", nameEn: "UAE" },
  { slug: "italy", nameTh: "อิตาลี", nameEn: "Italy" },
  { slug: "spain", nameTh: "สเปน", nameEn: "Spain" },
  { slug: "norway", nameTh: "นอร์เวย์", nameEn: "Norway" },
  { slug: "denmark", nameTh: "เดนมาร์ก", nameEn: "Denmark" },
  { slug: "finland", nameTh: "ฟินแลนด์", nameEn: "Finland" },
  { slug: "ireland", nameTh: "ไอร์แลนด์", nameEn: "Ireland" },
  { slug: "belgium", nameTh: "เบลเยียม", nameEn: "Belgium" },
  { slug: "austria", nameTh: "ออสเตรีย", nameEn: "Austria" },
  { slug: "hongkong", nameTh: "ฮ่องกง", nameEn: "Hong Kong" },
  { slug: "taiwan", nameTh: "ไต้หวัน", nameEn: "Taiwan" },
] as const;
